<template>
    <v-dialog
      v-model="dialog.visible"
      max-width="25%"
      persistent
    >
      <v-card>
        <v-card-text class="v-vard-text">
          <v-container>
            <div class="content-msg">Please enter the parameter</div>
            <input type="text" v-on:input="inputSome" class="content-input" v-model="parameterValue" />
            <span v-if="notEmpty" class="notEmpty">输入不能为空</span>
            <v-progress-linear
              v-if="dialog.showProgress"
              class="progress"
              color="primary"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn class="cancel" @click="dialog.visible = false;parameterValue = '';dialog.showProgress = false">Cancel</v-btn>
            </v-col>
            <v-col cols="6">
          <v-btn class="ensure" color="primary" @click="addFilterOk">Ok</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddFilterDialog',
  props: {
    dialog: Object
  },
  data () {
    return {
      parameterValue: '',
      notEmpty: false
    }
  },
  methods: {
    addFilterOk () {
      if (this.parameterValue === '') {
        this.notEmpty = true
      } else {
        this.$emit('getParameterValue', this.parameterValue)
        this.dialog.showProgress = false
      }
    },
    inputSome () {
      this.notEmpty = false
    }
  }
}
</script>

<style scoped>
.content-msg {
  color: #595959;
  font-size: 16px;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 20px;
}
.content-input {
  -webkit-appearance: none;
  background-color: #fff;
  border: none;
  font-size: 14px;
  display: block;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid rgba(0,0,0,.14);
  padding: 10px 13px;
  border-radius: 2px;
  transition: border-color .2s;
}
.cancel {
  background-color: #EFEFEF !important;
  color: #000;
  font-weight: bolder;
  font-size: 13px;
  padding: 0px 20px !important;
  float: right;
  border-radius: 2px;
  text-transform: none;
}
.ensure {
  color: #fff;
  font-weight: bolder;
  font-size: 13px;
  padding: 0px 20px !important;
  float: left;
  border-radius: 2px;
  text-transform: none;
}
.row {
  margin: -8px;
}
.notEmpty {
  color: red;
}
</style>
